module.exports = __webpack_public_path__ + "img/public/SiteIcons/claimPhotoClose.svg?6e6747ac";